import { RouteRecordRaw } from 'vue-router'

const crewMembersRoutes: RouteRecordRaw[] = [
  {
    path: '/crew/crew-members',
    name: 'crew-members.index',
    component: () => import('@/modules/crewing/views/crew-members/CrewMembersIndex.vue'),
    meta: {
      pageTitle: 'Crew members',
      breadcrumbs: ['Crew members']
    }
  },
  {
    path: '/crew/crew-members/create',
    name: 'crew-members.create',
    component: () => import('@/modules/crewing/views/crew-members/CrewMemberCreate.vue'),
    meta: {
      pageTitle: 'Create crew member',
      breadcrumbs: ['Crew members', 'Create']
    }
  },
  {
    path: '/crew/crew-members/:id',
    name: 'crew-members.show',
    component: () => import('@/modules/crewing/views/crew-members/CrewMembersShow.vue'),
    meta: {
      pageTitle: 'Crew members',
      breadcrumbs: ['Crew members']
    }
  },
  {
    path: '/crew/documents/:id',
    name: 'crew-documents.show',
    component: () => import('@/modules/crewing/views/crew-members/CrewDocumentShow.vue'),
    meta: {
      pageTitle: 'Crew member document',
      breadcrumbs: ['Crew members', 'Document']
    }
  }
]

export default crewMembersRoutes
